/**
 * 医生模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取医生列表
export const doctorList = (params) => {
  return req.get('/patient/doctor/list', params);
}

// 分页查询医生列表（医生档案等需筛选复诊费用等条件时使用）
export const doctorPage = (params) => {
  return req.get('/patient/doctor/page', params);
}

//查询医馆医生
export const queryDoctorDept = (params) => {
  return req.get('/patient/doctor/queryDoctorDept', params);
}
// 获取网诊医生列表
export const webChatList = (params) => {
  return req.get('/patient/doctor/webChatList', params);
}
// 获取网诊医生拖拽排序
export const webChatDoctorDragSort = (params) => {
  return req.post('/patient/doctor/dragSort', params);
}

// 获取有排班医生列表
export const schedulingDoctorList = (params) => {
  return req.get('/wechat/home/getDoctorByItem', params);
}

// 获取医生详情
export const doctorInfo = (doctorId) => {
  return req.get(`/patient/doctor/${doctorId}`);
}

// 新增医生
export const doctorAdd = (params) => {
  return req.post('/patient/doctor', params);
}

// 修改医生信息
export const doctorEdit = (params) => {
  return req.put('/patient/doctor', params);
}

// 删除医生信息
export const doctorDelete = (doctorId) => {
  return req.delete(`/patient/doctor/${doctorId}`);
}

// 医生停诊
export const doctorDimission = (doctorId) => {
  return req.post(`/patient/doctor/dimission/${doctorId}`);
}

// 获取医生挂号费
export const getPreRegisPrice = (params) => {
  return req.get(`/patient/doctor/getPreRegisPrice`, params);
}

// 获取查询有排班医生
export const getDoctorSchedulingList = (params) => {
  return req.get(`/patient/doctor/queryDoctorByScheduling`, params);
}

// 获取医助助理的医生列表
export const getHelpDoctorList = (params) => {
  return req.get(`/patient/doctor/doctorInfoByHelperId`, params);
}
// 绑定医助和医生
export const markHelpFlag = (params) => {
  return req.post(`/patient/doctor/markHelpFlag`,params);
}

// 获取叫号规则
export const getAllPolicy = (params) => {
  return req.get(`/order/registered/sign/allPolicy`,params);
}

//查询在职且小程序运行展示的医生列表
export const queryClientList = (params) => {
  return req.get(`/patient/doctor/queryList`,params);
}

// 获取医生复诊费配置（doctorId）
export const getRevisitPriceConfig = (doctorId) => {
  return req.get('/doctor/revisit-price/doctor', { doctorId });
}

// 保存医生复诊费配置（新增或修改）
export const saveRevisitPriceConfig = (params) => {
  return req.post('/doctor/revisit-price', params);
}

// 获取医生复诊价格
export const getRevisitRegisterPrice = (params) => {
  return req.get('/patient/doctor/register/price', params);
}